import * as React from 'react';
import { Toast, ToastType } from '../../../Components';
import { SituacaoDoDeposito } from '../../../Store/Deposito';
import styled from 'styled-components';

interface IProps {
  situacao: SituacaoDoDeposito | undefined;
  justificativa?: string;
}

const StyledItem = styled.div`
  padding: 5px;
`;

export const DepositoMessage: React.FC<IProps> = ({ situacao, justificativa }: IProps) => {
  switch (situacao) {
    case SituacaoDoDeposito.aprovado:
      return <Toast type={ToastType.success}>
        Seu depósito foi aceito pelo orientador
      </Toast>;
    case SituacaoDoDeposito.pendente:
      return <Toast type={ToastType.warning}>
        Seu depósito foi enviado para análise do aprovador
      </Toast>;
    case SituacaoDoDeposito.reprovado:
      return <>
        <Toast type={ToastType.error}>
          <StyledItem>Seu depósito foi rejeitado</StyledItem>
        </Toast>
        <Toast type={ToastType.error}>
          <StyledItem>Justificativa do Orientador e recomendações de correções: {justificativa}</StyledItem>
        </Toast>
        <Toast type={ToastType.info}>
          <StyledItem>Faça um novo depósito após as correções</StyledItem>
        </Toast>
      </>;
    default:
      return <></>;
  }
};